import React from "react";
import { Box, Heading, Text, List, ListItem, Link } from "@chakra-ui/react";
import PublicLayout from "../../components/public/Layout/layout";

const headingColor = "#2980b9";
const subheadingColor = "#34495e";

const styles = {
  container: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    lineHeight: 1.6,
    color: "#333",
    maxWidth: "800px",
    margin: "0 auto",
    padding: "30px",
  },
  contactBox: {
    background: "#f9f9f9",
    padding: "15px",
    borderLeft: "5px solid #2980b9",
    margin: "20px 0",
  },
  footer: {
    marginTop: "50px",
    fontSize: "0.9em",
    color: "#7f8c8d",
    textAlign: "center",
    borderTop: "1px solid #eee",
    paddingTop: "20px",
  },
};

const PrivacyPolicy = () => {
  return (
    <PublicLayout color="black" bg="white">
      <Box sx={styles.container} py={8}>
        <Heading as="h1" size="xl" color="#2c3e50" borderBottom="2px solid #eee" pb={2} mb={4}>
          Privacy Policy & Child Safety Standards
        </Heading>
        <Text as="p" fontWeight="bold" mb={6}>
          Last Updated: February 16, 2026
        </Text>

        <Text as="p" mb={6}>
          This policy describes the procedures of <strong>Asquera Practice / Rovoid</strong> regarding the collection, use, and disclosure of Your information, as well as our mandatory safety standards to protect children and prohibit illegal content.
        </Text>

        <Heading as="h2" size="lg" color={headingColor} mt={8} mb={4}>
          Child Safety Standards (CSAE/CSAM Policy)
        </Heading>
        <Text as="p" mb={4}>
          To ensure a safe environment for all users, <strong>Asquera Practice</strong> maintains a zero-tolerance policy regarding the safety of minors.
        </Text>

        <Heading as="h3" size="md" color={subheadingColor} mt={6} mb={3}>
          1. Explicit Prohibition of CSAE
        </Heading>
        <Text as="p" mb={4}>
          <strong>Asquera Practice / Rovoid</strong> strictly prohibits any form of <strong>Child Sexual Abuse and Exploitation (CSAE)</strong>. This includes the creation, sharing, uploading, or promotion of Child Sexual Abuse Material (CSAM) or any content that depicts the sexual exploitation of minors.
        </Text>

        <Heading as="h3" size="md" color={subheadingColor} mt={6} mb={3}>
          2. Reporting and Feedback Mechanisms
        </Heading>
        <Text as="p" mb={2}>
          We provide a dedicated in-app mechanism for users to report safety concerns and illegal content.
        </Text>
        <List spacing={2} mb={4}>
          <ListItem><strong>In-App Reporting:</strong> Users can flag profiles or content via the "Report" feature within the <strong>Asquera Practice</strong> application.</ListItem>
          <ListItem><strong>Immediate Action:</strong> Any identified CSAM will be removed immediately. Offending accounts will be permanently banned.</ListItem>
          <ListItem><strong>Legal Reporting:</strong> We comply with international requirements to report CSAM incidents to the National Center for Missing & Exploited Children (NCMEC) and relevant law enforcement.</ListItem>
        </List>

        <Heading as="h3" size="md" color={subheadingColor} mt={6} mb={3}>
          3. Child Safety Point of Contact
        </Heading>
        <Box sx={styles.contactBox}>
          <Text as="p" mb={2}>
            For inquiries or urgent reports specifically regarding child safety, please contact our <strong>Child Safety Officer</strong>:
          </Text>
          <Text as="p">
            <strong>Email:</strong>{" "}
            <Link href="mailto:asquerapractice@gmail.com" color="#2980b9">
              asquerapractice@gmail.com
            </Link>
            <br />
            <strong>Subject Line:</strong> Child Safety Concern - [Asquera Practice]
          </Text>
        </Box>

        <Heading as="h3" size="md" color={subheadingColor} mt={6} mb={3}>
          4. Compliance Declaration
        </Heading>
        <Text as="p" mb={8}>
          <strong>Asquera Practice / Rovoid</strong> declares full compliance with all applicable child safety laws and regulations, including local laws in Egypt and global safety standards for social applications.
        </Text>

        <Heading as="h2" size="lg" color={headingColor} mt={8} mb={4}>
          General Privacy Policy
        </Heading>
        <Heading as="h3" size="md" color={subheadingColor} mt={5} mb={3}>
          Definitions
        </Heading>
        <List spacing={2} mb={6}>
          <ListItem><strong>Application:</strong> Refers to <strong>Asquera Practice</strong>.</ListItem>
          <ListItem><strong>Company:</strong> Refers to <strong>Asquera Practice / Rovoid</strong>.</ListItem>
          <ListItem><strong>Personal Data:</strong> Any information relating to an identified or identifiable individual.</ListItem>
        </List>

        <Heading as="h3" size="md" color={subheadingColor} mt={5} mb={3}>
          Children's Data Privacy
        </Heading>
        <Text as="p" mb={6}>
          Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If we discover such data has been collected without parental consent, we take immediate steps to remove it from our servers.
        </Text>

        <Heading as="h3" size="md" color={subheadingColor} mt={5} mb={3}>
          Data Collection and Usage
        </Heading>
        <Text as="p" mb={8}>
          We collect Email addresses, names, and usage data to provide and maintain our Service and notify you about security updates.
        </Text>

        <Box as="footer" sx={styles.footer}>
          <Text as="p" mb={2}>
            &copy; 2026 Asquera Practice / Rovoid. All rights reserved.
          </Text>
          <Text as="p">
            Website:{" "}
            <Link href="https://asquera.com/#callCenter" target="_blank" rel="noopener noreferrer" color="#2980b9">
              asquera.com
            </Link>
          </Text>
        </Box>
      </Box>
    </PublicLayout>
  );
};

export default PrivacyPolicy;
